export default __webpack_public_path__ + "static/media/transfer.f63bde9d.svg";